"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialShare = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SocialShare = require("./SocialShare.styles");
var _SocialShare2 = require("./SocialShare.labels");
var _hooks = require("../../hooks");
var _A = require("../../UI/A");
var _Button = require("../../UI/Button");
var _Modal = require("../../Layout/Modal");
var _SocialShare3 = require("./SocialShare.helpers");
var _SocialShareBtn = require("./partials/SocialShareBtn");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _strings = require("../../utilities/strings");
var _Icon = require("../../UI/Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const teamsScript = {
  src: `https://teams.microsoft.com/share/launcher.js`,
  checkIfAlreadyLoaded: () => window.shareToMicrosoftTeams
};
const classRoomScript = {
  src: `https://apis.google.com/js/platform.js`,
  checkIfAlreadyLoaded: () => window.gapi?.sharetoclassroom
};
const useScriptsList = {
  scriptsList: [classRoomScript, teamsScript]
};
const SocialShare = props => {
  const getLabel = (0, _hooks.useLabels)({
    labels: _SocialShare2.labels
  });
  const {
    layout = 'popup',
    title,
    headerTitle = getLabel('share'),
    messageLineText,
    url = '',
    whatsappText,
    summary = '',
    onClose,
    onBack,
    shareList = []
  } = props;
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    isReady,
    error
  } = (0, _hooks.useScripts)(useScriptsList);
  const [isPopupOpen, setIsPopupOpen] = (0, _react.useState)(true);
  const [isCopySuccess, setIsCopySuccess] = (0, _react.useState)(false);
  const styles = (0, _SocialShare.useStyles)(props, isCopySuccess);
  const urlInputRef = (0, _react.useRef)(null);
  const shareMicrosoftTeamsBtnRef = (0, _react.useRef)(null);
  const googleClassroomBtnRef = (0, _react.useRef)(null);
  const timerRef = (0, _react.useRef)();
  const optionalData = (0, _SocialShare3.getOptionalDataByUrl)(url);
  const handleClose = event => {
    setIsPopupOpen(false);
    if (onClose) {
      onClose(event);
    }
  };
  const handleBack = event => {
    if (onBack) {
      onBack(event);
    }
  };
  const handleClick = () => {
    return false;
  };
  const handleCopyUrl = () => {
    if (urlInputRef?.current) {
      urlInputRef.current.select();
    }
    document.execCommand('copy');
    setIsCopySuccess(true);
    timerRef.current = setTimeout(() => {
      setIsCopySuccess(false);
    }, 5000);
  };
  (0, _react.useEffect)(() => {
    const timer = timerRef.current;
    return () => {
      if (timer) {
        window.clearTimeout(timer);
      }
    };
  }, []);
  (0, _react.useEffect)(() => {
    if (shareMicrosoftTeamsBtnRef.current && isReady) {
      window.shareToMicrosoftTeams?.renderButtons({
        elements: [shareMicrosoftTeamsBtnRef.current]
      });
    }
  }, [shareMicrosoftTeamsBtnRef, isReady, summary, title, url]);
  (0, _react.useEffect)(() => {
    if (googleClassroomBtnRef.current && isReady) {
      const maxLength = 1000;
      let pTitle = title || '';
      let pSummary = summary || '';
      pTitle = (0, _strings.clearHtmlTags)(pTitle);
      pSummary = (0, _strings.clearHtmlTags)(pSummary);
      if (pTitle.length + pSummary.length + url.length > maxLength) {
        pTitle = pTitle.substring(0, window.Math.max(100, maxLength - pSummary.length - url.length));
        pSummary = pSummary.substring(0, maxLength - pTitle.length - url.length);
      }
      const pTitleEncodeLength = window.encodeURIComponent(pTitle).length;
      const urlEncodeLength = window.encodeURIComponent(url).length;
      while (pSummary.length > 0 && pTitleEncodeLength + urlEncodeLength + window.encodeURIComponent(pSummary).length > maxLength) {
        pSummary = pSummary.substring(0, pSummary.length - 1);
      }
      window.gapi?.sharetoclassroom?.render(googleClassroomBtnRef.current, {
        url: url,
        body: pSummary,
        title: pTitle,
        itemtype: 'material'
      });
    }
  }, [googleClassroomBtnRef, isReady, summary, title, url]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-SocialShare'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal, {
      layout: layout,
      isOpen: isPopupOpen,
      onClose: handleClose,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Header, {
        title: headerTitle,
        subTitle: title
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal.Content, {
        children: [messageLineText && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "cc-SocialShare__message",
          children: messageLineText
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: styles['cc-SocialShare__options'],
          children: [shareList.includes('link') && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: styles['cc-SocialShare__option'],
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: styles['cc-SocialShare__option__input'],
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
                ref: urlInputRef,
                readOnly: true,
                value: url,
                "aria-label": getLabel('socialShare_socialBtn_link')
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: styles['cc-SocialShare__option__feedback'],
              children: getLabel('socialShare_urlCopyFeedback')
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
              id: "ccSocialShareButton",
              color: "basic",
              view: "outlined",
              size: "stretch",
              shape: "roundedRectangle",
              onClick: handleCopyUrl,
              category: "shareFlow",
              label: "copyLink",
              optionalData: optionalData,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SocialShareBtn.SocialShareBtn, {
                id: "link",
                icon: "Link",
                text: getLabel('socialShare_socialBtn_link'),
                isSuccess: isCopySuccess
              })
            })]
          }), shareList.includes('whatsapp') && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-SocialShare__option'],
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
              isBtnView: true,
              color: "basic",
              view: "outlined",
              size: "stretch",
              shape: "roundedRectangle",
              to: `https://api.whatsapp.com/send?text=${whatsappText ? window.encodeURIComponent(whatsappText) + ' %0a ' : ''}${window.encodeURIComponent(url)}`,
              target: "_blank",
              category: "shareFlow",
              label: "shareInWhatsApp",
              optionalData: optionalData,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SocialShareBtn.SocialShareBtn, {
                id: "whatsapp",
                icon: "Whatsapp",
                text: getLabel('socialShare_socialBtn_whatsapp')
              })
            })
          }), shareList.includes('googleClassroom') && error?.failedScriptData?.src !== classRoomScript?.src && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: styles['cc-SocialShare__option'],
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              ref: googleClassroomBtnRef,
              className: styles['cc-SocialShare__option__mask']
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
              id: "ccSocialShareGoogleClassButton",
              color: "basic",
              view: "outlined",
              size: "stretch",
              shape: "roundedRectangle",
              customStyle: {
                background: themeColors?.general.light
              },
              pointerEvents: "none",
              category: "shareFlow",
              label: "shareClassroom",
              optionalData: optionalData,
              onClick: handleClick,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SocialShareBtn.SocialShareBtn, {
                id: "googleClassroom",
                text: getLabel('socialShare_socialBtn_googleClassroom'),
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                  name: "GoogleClassroom",
                  width: 24,
                  height: 24
                })
              })
            })]
          }), shareList.includes('teams') && error?.failedScriptData?.src !== teamsScript?.src && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: styles['cc-SocialShare__option'],
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              ref: shareMicrosoftTeamsBtnRef,
              className: styles['cc-SocialShare__option__mask'],
              "data-preview": true,
              "data-href": url,
              "data-assign-title": title?.substring(0, 50) || '',
              "data-assign-instr": (0, _strings.clearHtmlTags)(summary, 200)
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
              id: "ccSocialShareMicrosoftTeamsButton",
              color: "basic",
              view: "outlined",
              size: "stretch",
              shape: "roundedRectangle",
              pointerEvents: "none",
              category: "shareFlow",
              label: "shareTeams",
              optionalData: optionalData,
              onClick: handleClick,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SocialShareBtn.SocialShareBtn, {
                id: "teams",
                text: getLabel('socialShare_socialBtn_microsoftTeams'),
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                  name: "MicrosoftTeams",
                  width: 24,
                  height: 24
                })
              })
            })]
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer, {
        justifyContent: "center",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            view: "outlined",
            color: "primary",
            onClick: onBack ? handleBack : handleClose,
            id: "ccSocialShareBackButton",
            children: getLabel(onBack ? 'back' : 'close')
          })
        })
      })]
    })
  });
};
exports.SocialShare = SocialShare;